
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {CalendarRule} from './CalendarRule';
import {FieldModelCalendarRule} from './CalendarRule';
import {TimezoneInfo} from './TimezoneInfo';
import {FieldModelTimezoneInfo} from './TimezoneInfo';

/**
 * CalendarRulesGetResponse struct
 */
class CalendarRulesGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!string=} symbol
   * @param {!Array=} calendarRules
   * @param {!TimezoneInfo=} timezoneInfo
   * @constructor
   */
  constructor (parent = new Response(), symbol = '', calendarRules = [], timezoneInfo = new TimezoneInfo()) {
    super()
    super.copy(parent)
    this.Symbol = symbol
    this.CalendarRules = calendarRules
    this.TimezoneInfo = timezoneInfo
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CalendarRulesGetResponse}
   * @param {!CalendarRulesGetResponse} other Other struct
   * @returns {!CalendarRulesGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Symbol != null) {
      this.Symbol = other.Symbol
    } else {
      this.Symbol = null
    }
    if (other.CalendarRules != null) {
      this.CalendarRules = []
      for (let item of other.CalendarRules) {
        if (item != null) {
          let tempItem
          tempItem = CalendarRule.fromObject(item)
          this.CalendarRules.push(tempItem)
        } else {
          this.CalendarRules.push(null)
        }
      }
    } else {
      this.CalendarRules = null
    }
    if (other.TimezoneInfo != null) {
      this.TimezoneInfo = TimezoneInfo.fromObject(other.TimezoneInfo)
    } else {
      this.TimezoneInfo = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CalendarRulesGetResponse}
   * @returns {!CalendarRulesGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CalendarRulesGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CalendarRulesGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CalendarRulesGetResponse}
   * @param {!CalendarRulesGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CalendarRulesGetResponse)) {
      throw new TypeError('Instance of CalendarRulesGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CalendarRulesGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Symbol: ((this.Symbol != null) ? this.Symbol : null),
      CalendarRules: ((this.CalendarRules != null) ? Array.from(this.CalendarRules, item => ((item != null) ? item : null)) : null),
      TimezoneInfo: ((this.TimezoneInfo != null) ? this.TimezoneInfo : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CalendarRulesGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CalendarRulesGetResponse} other Object value
   * @returns {!CalendarRulesGetResponse} Created struct
   */
  static fromObject (other) {
    return new CalendarRulesGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CalendarRulesGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CalendarRulesGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CalendarRulesGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5133
  }
}

export { CalendarRulesGetResponse };

/**
 * Fast Binary Encoding CalendarRulesGetResponse field model
 */
class FieldModelCalendarRulesGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Symbol = new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.CalendarRules = new fbe.FieldModelVector(new FieldModelCalendarRule(buffer, this.Symbol.fbeOffset + this.Symbol.fbeSize), buffer, this.Symbol.fbeOffset + this.Symbol.fbeSize)
    this.TimezoneInfo = new FieldModelTimezoneInfo(buffer, this.CalendarRules.fbeOffset + this.CalendarRules.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Symbol.fbeSize + this.CalendarRules.fbeSize + this.TimezoneInfo.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Symbol.fbeExtra + this.CalendarRules.fbeExtra + this.TimezoneInfo.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCalendarRulesGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5133
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbol.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbol.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbol.fbeSize

    if ((fbeCurrentSize + this.CalendarRules.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CalendarRules.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CalendarRules.fbeSize

    if ((fbeCurrentSize + this.TimezoneInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TimezoneInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimezoneInfo.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!CalendarRulesGetResponse} fbeValue Default value, defaults is new CalendarRulesGetResponse()
   * @returns {!CalendarRulesGetResponse} CalendarRulesGetResponse value
   */
  get (fbeValue = new CalendarRulesGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!CalendarRulesGetResponse} fbeValue CalendarRulesGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbol.fbeSize) <= fbeStructSize) {
      fbeValue.Symbol = this.Symbol.get()
    } else {
      fbeValue.Symbol = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbol.fbeSize

    if ((fbeCurrentSize + this.CalendarRules.fbeSize) <= fbeStructSize) {
      this.CalendarRules.get(fbeValue.CalendarRules)
    } else {
      fbeValue.CalendarRules.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CalendarRules.fbeSize

    if ((fbeCurrentSize + this.TimezoneInfo.fbeSize) <= fbeStructSize) {
      fbeValue.TimezoneInfo = this.TimezoneInfo.get()
    } else {
      fbeValue.TimezoneInfo = new TimezoneInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TimezoneInfo.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCalendarRulesGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {!CalendarRulesGetResponse} fbeValue CalendarRulesGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCalendarRulesGetResponse}
   * @param {CalendarRulesGetResponse} fbeValue CalendarRulesGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Symbol.set(fbeValue.Symbol)
    this.CalendarRules.set(fbeValue.CalendarRules)
    this.TimezoneInfo.set(fbeValue.TimezoneInfo)
  }
}

export { FieldModelCalendarRulesGetResponse };

/**
 * Fast Binary Encoding CalendarRulesGetResponse model
 */
class CalendarRulesGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCalendarRulesGetResponse(this.buffer, 4)
  }

  /**
   * Get the CalendarRulesGetResponse model
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!FieldModelCalendarRulesGetResponse} model CalendarRulesGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CalendarRulesGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCalendarRulesGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CalendarRulesGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CalendarRulesGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CalendarRulesGetResponseModel}
   * @param {!CalendarRulesGetResponse} value CalendarRulesGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CalendarRulesGetResponseModel}
   * @param {!CalendarRulesGetResponse} value CalendarRulesGetResponse value, defaults is new CalendarRulesGetResponse()
   * @return {!object} Deserialized CalendarRulesGetResponse value and its size
   */
  deserialize (value = new CalendarRulesGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CalendarRulesGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CalendarRulesGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CalendarRulesGetResponseModel}
   * @param {!number} prev Previous CalendarRulesGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CalendarRulesGetResponseModel };
